<template>
    <el-container>
        <fhead></fhead>
        <el-main>
            <el-breadcrumb class="center" separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">{{$t('l.home')}}</el-breadcrumb-item>
                <el-breadcrumb-item>{{$t('l.account.index.title')}}{{$t('l.hour')}}</el-breadcrumb-item>
            </el-breadcrumb>
            <el-card class="box-card center" style="margin-top: 16px">
                <div slot="header" class="clearfix">
                    <span>{{$t('l.account.index.title1')}}</span>
                </div>
                <el-table class="center"
                          v-loading="Loading"
                          stripe
                          :data="List"
                          style="width: 100%">
                    <el-table-column
                            type="index"
                            :index="indexMethod"
                            label=""
                            width="60">
                    </el-table-column>
                    <el-table-column
                            :label="$t('l.account.addr')"
                            width="360">
                        <template slot-scope="scope">
                            {{scope.row.accountRS}}
<!--                            <router-link style="position: relative" :to="'/account/'+scope.row.accountRS">-->
<!--                                <el-button type="text"> {{scope.row.accountRS}}-->
<!--                                    <div v-show="scope.row.NAME!=null" style="text-align: left;position: absolute">-->
<!--                                        {{scope.row.NAME}}-->
<!--                                    </div>-->
<!--                                </el-button>-->
<!--                            </router-link>-->
                        </template>
                    </el-table-column>
                    <el-table-column
                            :label="$t('l.account.index.BALANCE')"
                            width="180">
                        <template slot-scope="scope">
                            {{$g.wallet.amount(scope.row.BALANCE)}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            :label="'HASH'"
                            width="340">
                        <template slot-scope="scope">
                            <a v-if="scope.row.HASH" :href="'https://blockscout.com/etc/mainnet/tx/'+scope.row.HASH">

                                {{scope.row.HASH}}
                            </a>
                        </template>
                    </el-table-column>
                    <el-table-column
                            :label="$t('l.account.index.DESCRIPTION')">
                        <template slot-scope="scope">
                            {{scope.row.DESCRIPTION}}
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                        style="text-align: center;"
                        @current-change="handleCurrentChange"
                        :current-page.sync="currentPage"
                        :page-size="15"
                        layout="total, prev, pager, next"
                        :total="total">
                </el-pagination>
            </el-card>
        </el-main>
        <el-footer class="footer">
            COPYRIGHT © 2018. ALL RIGHTS RESERVED. DESIGNED BY
            <a target="_blank" href="https://hebeblock.com/">HEBEBLOCK</a>
        </el-footer>

    </el-container>
</template>


<script>
    import fhead from './../fhead.vue';

    export default {
        name: 'accounts',
        components: {
            fhead
        },
        data() {
            return {
                Loading: false,
                List: [],
                currentPage: 1,
                total: 0,
                testList: []
            }
        },
        methods: {
            indexMethod(index) {
                return (index + 1) + (this.currentPage - 1) * 15;
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.accounts();
            },
            init() {
                this.$ajax({
                    method: 'get',
                    url: this.$store.state.walletnxt + 'block/accountCount',
                }).then(response => {
                    this.total = parseInt(response[0].COUNT);
                });
                this.accounts()
            },
            async accounts() {
                this.Loading = true;
                this.$ajax({
                    method: 'get',
                    url: this.$store.state.walletnxt + 'block/account?page=' + this.currentPage,
                }).then(async response => {
                    this.Loading = false;
                    console.log(response);
                    let list = []
                    let accountModel = [
                        {
                            "accountRS": "HEBE-7DL8-ZNWY-ZTR7-BNK8S",
                            "name": "未流通，已多签"
                        },
                        {
                            "accountRS": "HEBE-HS7R-WWS8-NX2R-FRWAU",
                            "name": "未流通，已多签"
                        },
                        {
                            "accountRS": "HEBE-3ZTW-U8GT-THBJ-4GNW7",
                            "name": "未流通，已多签"
                        },
                        {
                            "accountRS": "HEBE-7DL8-ZNWY-ZTR7-BNK8S",
                            "name": "未流通，已多签"
                        },
                        {
                            "accountRS": "HEBE-P7W9-LBB6-B6LN-64HDZ",
                            "name": "未流通，已多签"
                        },
                        {
                            "accountRS": "HEBE-GU3L-V374-A35J-6DM4C",
                            "name": "未流通，已多签"
                        },
                        {
                            "accountRS": "HEBE-8CAD-ZPNW-CQ53-BAXLR",
                            "name": "未流通，已多签"
                        },
                        {
                            "accountRS": "HEBE-CG7M-M25X-P5VB-9V9VL",
                            "name": "未流通，已多签"
                        },
                        {
                            "accountRS": "HEBE-GUYS-WZ7S-5KJ3-4PEVR",
                            "name": "未流通，已多签"
                        },
                        {
                            "accountRS": "HEBE-X949-FWSQ-BQFD-7B5PQ",
                            "name": "未流通，已多签"
                        },
                        {
                            "accountRS": "HEBE-WDT8-UA4W-BSZY-DBCWT",
                            "name": "未流通，已多签"
                        },
                        {
                            "accountRS": "HEBE-M3JY-Z4XD-TFRF-4F3EQ",
                            "name": "未流通，已多签"
                        }, {
                            "accountRS": "HEBE-PUCZ-5RFG-UY2C-9M2A7",
                            "name": "未流通，已多签"
                        },
                    ]

                    response.forEach(item => {
                        if (JSON.stringify(accountModel).indexOf(item.accountRS) == -1) {
                            list.push(item)
                        }
                    })
                    for (let i = 0; i < list.length; i++) {
                        let res = await this.$ajax({
                            method: 'get',
                            url: "https://apis.etcswap.cc/toetc?addr=" + list[i].accountRS,
                        })
                        if (res.etcmodel) {
                            list[i].DESCRIPTION = res.etcmodel.etc
                            list[i].HASH= res.etcmodel.hash
                        }
                    }


                    this.List = list;
                });

            }
        },
        created: function () {
            this.init();
        }
    }
</script>


<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/account/index.vue